if (!customElements.get('mc-accessory-recs')) {
  customElements.define('mc-accessory-recs', class extends HTMLElement {
    connectedCallback() {
      if (this.track) return;
      this.dataset.js = '';
      this.track = this.querySelector('[data-track]');
      this.status = this.querySelector('[data-status]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');

      new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.classList.add('is-in');
        observer.disconnect();
        setTimeout(() => this.classList.add('is-settled'), 1200);
      }, { threshold: 0.2 }).observe(this);

      const step = (direction) => {
        const item = this.track.querySelector('.mca__item');
        this.track.scrollBy({ left: direction * (item.offsetWidth + 10) * 2, behavior: 'smooth' });
      };
      this.prev.addEventListener('click', () => step(-1));
      this.next.addEventListener('click', () => step(1));
      this.track.addEventListener('scroll', () => this.syncArrows(), { passive: true });
      window.addEventListener('resize', () => this.syncArrows(), { passive: true });
      this.syncArrows();

      this.track.addEventListener('click', (e) => {
        const button = e.target.closest('button.mca__add');
        if (button) this.add(button);
      });
    }

    syncArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.toggleAttribute('data-scrollable', max > 4);
      this.prev.disabled = this.track.scrollLeft < 4;
      this.next.disabled = this.track.scrollLeft > max - 4;
    }

    async add(button) {
      if (button.dataset.state === 'loading') return;
      button.dataset.state = 'loading';
      const name = button.dataset.name;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(button.dataset.variant), quantity: 1 })
        });
        if (!response.ok) throw new Error('stock');
        button.dataset.state = 'done';
        this.status.innerHTML = '';
        this.status.append(`${name} se agregó. `);
        const link = document.createElement('a');
        link.href = '/cart';
        link.textContent = 'Ver carrito';
        this.status.append(link);
        this.refreshCart();
        setTimeout(() => { delete button.dataset.state; }, 2400);
      } catch (error) {
        button.dataset.state = 'error';
        this.status.textContent = `No pudimos agregar ${name}. Puede que no quede stock.`;
        setTimeout(() => { delete button.dataset.state; }, 600);
      }
    }

    // Usa el mismo carrito lateral del tema, para que muestre lo recién agregado.
    async refreshCart() {
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('.js-cart-count').forEach((el) => { el.textContent = cart.item_count; });
      const configEl = document.getElementById('cart-config');
      const ajaxCart = window.Shopify && Shopify.theme && Shopify.theme.ajaxCart;
      if (!configEl || !ajaxCart || !ajaxCart.updateView) return;
      try {
        ajaxCart.updateView(JSON.parse(configEl.innerHTML || '{}'), cart);
      } catch (error) {
        console.warn('No se pudo actualizar el carrito lateral', error);
      }
    }
  });
}